import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Resume.css";

const Resume = (props) => {
  /* STATES */
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  /* REUSABLE MINOR COMPONENTS */
  const ResumeHeading = (props) => {
    return (
      <div className="resume-heading">
        <div className="resume-main-heading">
          <div className="heading-bullet"></div>
          <span>{props.heading ? props.heading : ""}</span>
          {props.fromDate && props.toDate ? (
            <div className="heading-date">
              {props.fromDate + "-" + props.toDate}
            </div>
          ) : (
            <div></div>
          )}
        </div>
        <div className="resume-sub-heading">
          <span>{props.subHeading ? props.subHeading : ""}</span>
        </div>
        <div className="resume-heading-description">
          <span>{props.description ? props.description : ""}</span>
        </div>
      </div>
    );
  };

  /* STATIC RESUME DATA FOR THE LABELS*/
  const resumeBullets = [
    { label: "Educational Background", logoSrc: "educations.jpg" },
    { label: "Programming Skills", logoSrc: "programming-skills.svg" },
    { label: "Professional Experience", logoSrc: "work-history.svg" },
    { label: "Hobbies and Interests", logoSrc: "interests.svg" },
    { label: "Additional Endeavors", logoSrc: "achievement.svg" },
    //
  ];

  //here we have

  const programmingSkillsDetails = [
    { skill: "DSA / LLD", ratingPercentage: 75 },
    { skill: "JavaScript / TypeScript", ratingPercentage: 85 },
    { skill: "React JS / Redux", ratingPercentage: 90 },
    { skill: "NodeJS / ExpressJS ", ratingPercentage: 85 },
    // { skill: "Linux / AWS", ratingPercentage: 80 },
    // { skill: "Python / Django", ratingPercentage: 85 },
    { skill: "MongoDB / SQL", ratingPercentage: 85 },
    { skill: "HTML / CSS", ratingPercentage: 95 },
    { skill: "Git / Github / Postman", ratingPercentage: 80 },
    { skill: "Networking / Linux", ratingPercentage: 75 },

    { skill: "Jenkins / Docker", ratingPercentage: 65 },
    { skill: "Kubernetes / AWS", ratingPercentage: 70 },
  ];

  const projectsDetails = [
    {
      title: "Project : Lead Management System",
      duration: { fromDate: "2023", toDate: "2024" },
      description: `
        The Lead Management System was designed to efficiently manage and track insurance leads.
         Developed user interfaces using React.js, ensuring an intuitive and user-friendly design.
         Integrated RESTful APIs for real-time data updates across web and mobile platforms.
         Organized and streamlined customer data, enabling better tracking and follow-ups to enhance lead conversion rates.
         Optimized application performance, ensuring seamless integration and fast load times.`,
    },

    {
      title: "Project : Coding Assessment Platform",
      duration: { fromDate: "2022", toDate: "2023" },
      description: `
       Coding Assessments: Allows students and developers to solve coding challenges in a built-in IDE, with automatic grading based on pre-set evaluation criteria.
         Worked on a coding assessment platform that provided an integrated coding IDE for users and designed the frontend UI.
        Implemented logic for automatic evaluation of students' code submissions based on predefined criteria.
         Played a key role in ensuring the platform provided an efficient user experience`,
    },
  ];

  const resumeDetails = [
    <div className="resume-screen-container" key="education">
      <ResumeHeading
        heading={"University of London:"}
        subHeading={`I'm currently pursuing the Mathematics for Computer Science certification from the University of London, a 26-week program focused on mathematical computation. It covers discrete mathematics, mathematical theory & analysis, logic and propositional calculus, critical thinking, and graph theory while exploring how mathematics underpins operating systems, hardware, and software. The program also applies these concepts to real-world challenges`}
        fromDate={"2024"}
        toDate={"2025"}
      />

      <div className="marwari-clg">
        <ResumeHeading
          heading={" MASAI CODING SCHOOL:"}
          subHeading={
            "Completed a rigorous 36-week live-instructed MERN Stack Development Certification Program, covering HTML, CSS, JavaScript, React, Node.js, Express.js, and MongoDB and other DataBases, along with fundamental computer science concepts such as Data Structures and Algorithms. Gained hands-on expertise in full-stack web development by building real-world projects."
          }
          fromDate={"2021"}
          toDate={"2022"}
        />
      </div>

      <ResumeHeading
        heading={" RAJASTHAN TECHNICAL UNIVERSITY:"}
        subHeading={
          "B.Tech in Mechanical Engineering | Explored Fundamentals of Computer Science as electives, focusing on Frontend & Backend Development, along with Data Structures & Algorithms (DSA)."
        }
        fromDate={"2013"}
        toDate={"2017"}
      />
      {/* <div className="clg-project">
        <p className="stacker">PROJECT: STACKER & 3D PRINTING</p>
        <span className="stacker-details">
         Details:It reduces the time consumption.
        </span>
      <p className="three-d">
         3D Printing Details: Made non-metallic nut-bolt.
       </p>
      <p className="iit-delhi">Performed -Auto mobile workshop at IIT Delhi.</p>
       
      </div> */}
    </div>,

    /* PROGRAMMING SKILLS */
    <div
      className="resume-screen-container programming-skills-container"
      key="programming-skills"
    >
      {programmingSkillsDetails.map((skill, index) => (
        <div className="skill-parent" key={index}>
          <div className="heading-bullet bullet-down"></div>
          <span>{skill.skill}</span>
          <div className="skill-percentage">
            <div
              style={{ width: skill.ratingPercentage + "%" }}
              className="active-percentage-bar"
            ></div>
          </div>
        </div>
      ))}
    </div>,

    /* PROJECTS */
    <div className="resume-screen-container" key="projects">
      {projectsDetails.map((projectsDetails, index) => (
        <ResumeHeading
          key={index}
          heading={projectsDetails.title}
          subHeading={projectsDetails.subHeading}
          description={projectsDetails.description}
          fromDate={projectsDetails.duration.fromDate}
          toDate={projectsDetails.duration.toDate}
        />
      ))}
    </div>,

    /* Interests */
    <div className="resume-screen-container" key="interests">
      <ResumeHeading
        heading="Technology:"
        description="Driven by a deep curiosity for technology and computer science, I am passionate about exploring new concepts and solving complex problems. I thrive on staying at the forefront of innovation, continuously expanding my knowledge to build impactful, cutting-edge solutions that make a difference."
      />
      <ResumeHeading
        heading="Tech Conferences:"
        description=" actively attend tech conferences and engage with industry professionals, gaining diverse insights into emerging technologies and trends. These experiences not only broaden my perspective but also inspire innovative approaches in my work. "
      />
      <ResumeHeading
        heading="Freelancing:"
        description="As a freelancer, I collaborate with clients to create custom solutions that align with their business goals. I specialize in web development and software solutions, providing tailored, high-quality products that meet client needs. This experience has allowed me to refine my problem-solving skills, work independently, and manage client relationships effectively."
      />
    </div>,

    <div className="resume-screen-container" key="Achievements">
      <div className="experience-container">
        <div className="cs-it">
          <ResumeHeading
            heading={"Apart from proffession"}
            subHeading={"An Old Story:"}
            // fromDate={"2021"}
            // toDate={"Present"}
          />
        </div>
        <div className="experience-description">
          <span className="resume-description-text"></span>
        </div>
        <div className="experience-description">
          <span className="resume-description-text">
            - Represented state level cricket tournament in different states.{" "}
            <br />
            - I was the vice-captain of my state cricket team.
            <br />
            - Represented district level Tournaments in Badminton & and won the
            title. <br />
            - Four time college champion in badminton. <br />- Achieved
            Mr.Athletic title from college.
          </span>
          <br />
        </div>
        {/* <br /> */}

        <div className="my-stuff">
          <ResumeHeading
            heading={"Healing Zone"}
            subHeading={"That Walks with me:"}
          />
        </div>
        <br />
        <div className="intrest">
          <span className="resume-description-text-my">
            - Singing in public and performing musical pieces
            <br />
            - I play different types of musical instruments like, Guitar, Piono
            , Mouth Organ and more
            <br />
            - I do watch Netflix when I am bored.
            <br />- Finding peace and inspiration in the beauty of the Nature or
            outdoors.
          </span>
        </div>
      </div>
    </div>,
  ];

  const handleCarousal = (index) => {
    let offsetHeight = 360;

    let newCarousalOffset = {
      style: { transform: "translateY(" + index * offsetHeight * -1 + "px)" },
    };

    setCarousalOffsetStyle(newCarousalOffset);
    setSelectedBulletIndex(index);
  };

  const getBullets = () => {
    return resumeBullets.map((bullet, index) => (
      <div
        onClick={() => handleCarousal(index)}
        className={
          index === selectedBulletIndex ? "bullet selected-bullet" : "bullet"
        }
        key={index}
      >
        <img
          className="bullet-logo"
          src={require(`../../assets/SVG/${bullet.logoSrc}`)}
          alt={bullet.label}
          width="15px"
        />

        <span className="bullet-label">{bullet.label}</span>
      </div>
    ));
  };

  const getResumeScreens = () => {
    return (
      <div
        style={carousalOffsetStyle.style}
        className="resume-details-carousal"
      >
        {resumeDetails.map((ResumeDetail) => ResumeDetail)}
      </div>
    );
  };

  useEffect(() => {
    return () => {
      /* UNSUBSCRIBE THE SUBSCRIPTIONS */
      fadeInSubscription.unsubscribe();
    };
  }, [fadeInSubscription]);

  return (
    <div
      className="resume-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="resume-content">
        <ScreenHeading
          title={"Career Summary"}
          subHeading={"My formal Bio Details"}
        />
        <div className="resume-card">
          <div className="resume-bullets">
            <div className="bullet-container">
              <div className="bullet-icons"></div>
              <div className="bullets">{getBullets()}</div>
            </div>
          </div>

          <div className="resume-bullet-details">{getResumeScreens()}</div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
